import { type ConfirmationModalProps, ConfirmationModal, Text } from '@shared/components';

type PublishQuestionModalProps = Pick<
  ConfirmationModalProps,
  'loading' | 'onClose' | 'open' | 'onAccept'
>;

export default function PublishQuestionModal(props: Readonly<PublishQuestionModalProps>) {
  const { loading: isLoading, open: isOpen, onClose, onAccept } = props;

  return (
    <ConfirmationModal
      title='Publish Question?'
      open={isOpen}
      loading={isLoading}
      acceptText='Publish'
      content={
        <Text>
          เมื่อทำการ Publish แล้ว{' '}
          <Text variant='body1Semibold' component='span'>
            จะไม่สามารถแก้ไขรายละเอียดได้อีก
            <br />
            จนกว่าจะเปลี่ยนสถานะคำถามเป็น Pending
          </Text>
          <br />
          <br />
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      }
      onDiscard={onClose}
      onClose={onClose}
      onAccept={onAccept}
    />
  );
}
